import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from "react-router-dom";
import { isEmpty } from "lodash";

import { Box, Dropdown, Option, OptionDescription } from "@launchmetrics/lm-ui";

import { ReactComponent as XlsIcon } from 'vendor/svg/report/xls-icon.svg';
import { ReactComponent as OnlineIcon } from 'vendor/svg/report/online-icon.svg';
import { ReactComponent as ReportIcon } from 'vendor/svg/report/report-manager.svg';
import { ReactComponent as PowerpointIcon } from 'vendor/svg/report/powerpoint-icon.svg';

import { RootState } from "store";
import { resetReport, setReportType } from "store/article/report/reducers";
import featureFlags from "lib/featureFlags";
import { useOldestDocumentDateFromFeeds } from "lib/hooks";
import DashboardDropDown from "../Form/Export/DashboardDropDown";

import { useStyles } from "./styles";

export function ReportDropdown() {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { reportDropdownTitle, disabledOption } = useStyles();
	const filters = useSelector((state: RootState) => state.search.form.insightsFilters);
	const feeds = (!isEmpty(filters) && !isEmpty(filters.feeds)) ? filters.feeds.values : [];
	const oldestDocumentDateHook = useOldestDocumentDateFromFeeds(feeds);

	const location = useLocation();
	const history = useHistory();

	const showReportPanel = useCallback(value => {
		if(value === 'excel' && featureFlags.isEnabled('excel-report-builder')) {
			const excelReportBuilderButton = document.getElementById('excel-report-builder-button');
			if (excelReportBuilderButton) excelReportBuilderButton.click();
			return;
		}

		dispatch(resetReport());
		dispatch(setReportType({ type: value }));
		if(location.pathname.includes('/report') && value !== 'excel') {
			history.push('/article');
		}
	}, [dispatch, history, location.pathname]);

	const oldestDocumentDate = featureFlags.isEnabled('excel-report-builder') ? oldestDocumentDateHook : '';

	const disabled = () => !featureFlags.isEnabled('excel-report-builder') ? disabledOption : '';

	return (
		<Dropdown
			id="reportDropdownBtn"
			label={t('reports_manager.article.dropdown.label')}
			leftIcon={<ReportIcon />}
			onChange={value => showReportPanel(value)}
			variant="primary"
			popoverProps={{ placement: 'bottom-end' }}
		>
			<>
				<Option id="reportDropdownExcelBtn" value="excel" styleProps={{ ...disabled() }}>
					<Box styleProps={reportDropdownTitle}><XlsIcon />{t('reports_manager.article.dropdown.excel.title')}</Box>
					<OptionDescription>
						{t('reports_manager.article.dropdown.excel.subtitle')}
					</OptionDescription>

					<div hidden={true}>
						<DashboardDropDown
							filters={filters}
							entrypoint='report'
							availableDataDate={oldestDocumentDate}
							item={{
								id: 'excel-report-builder-button',
								icon: <XlsIcon style={{ opacity: '0.54' }} />,
								disabled: !featureFlags.isEnabled('excel-report-builder'),
								label: t('reports_manager.article.dropdown.excel.title')
							}} />
					</div>
				</Option>

				<Option id="reportDropdownPowerpointBtn" value="powerpoint">
					<Box styleProps={reportDropdownTitle}><PowerpointIcon />{t('reports_manager.article.dropdown.powerpoint.title')}</Box>
					<OptionDescription>
						{t('reports_manager.article.dropdown.powerpoint.subtitle')}
					</OptionDescription>
				</Option>
				<Option id="reportDropdownOnlineBtn" value="online">
					<Box styleProps={reportDropdownTitle}><OnlineIcon />{t('reports_manager.article.dropdown.online.title')}</Box>
					<OptionDescription>
						{t('reports_manager.article.dropdown.online.subtitle')}
					</OptionDescription>
				</Option>
			</>
		</Dropdown>
	);
}
